import PropTypes from 'prop-types'
import GroupEventCardLarge from '@components/group-event-card-large/group-event-card-large'
import ProgramCardAlgolia from '@components/coach-offering-programs/program-card'

/**
 * This card is a wrapper that does the work of translating algolia Group Event results to
 * a shape that the GroupEventCardLarge component expects, or serving a Program Card for a
 * JRL or FG Program.
 */
const GroupEventSearchResultCard = ({ event, location, logoImageUrl }) => {
  /* eslint-disable camelcase */
  const {
    title,
    start_date_time,
    end_date_time,
    slug,
    max_attendance,
    registration_count,
    featured_image_url,
    price_in_cents,
    lesson_count,
    coach_facility_name,
    coach_facility_timezone,
    registration_full,
    tags,
    has_waitlist,
  } = event

  const isProgram = tags.includes('PGA Jr. League') || tags.includes('PGA Family Cup')

  return isProgram ? (
    <ProgramCardAlgolia key={event.id} event={event} openInNewTab />
  ) : (
    <GroupEventCardLarge
      key={slug}
      logoImageUrl={logoImageUrl}
      event={{
        title,
        startDateTime: start_date_time,
        endDateTime: end_date_time,
        slug,
        maxAttendance: max_attendance,
        registrationCount: registration_count,
        featuredImageUrl: featured_image_url,
        priceInCents: price_in_cents,
        sessions: Array.from('1'.repeat(lesson_count)), // Component uses `sessions.length`
        coachFacility: {
          name: coach_facility_name,
          timezone: coach_facility_timezone,
        },
        registrationFull: registration_full,
        hasWaitlist: has_waitlist,
      }}
      dataAttrs={{
        'aria-label': 'View event',
        'data-gtm-button-name': `view-event-${location}`,
      }}
      openInNewTab
    />
  )
}

GroupEventSearchResultCard.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string.isRequired,
    start_date_time: PropTypes.string,
    end_date_time: PropTypes.string,
    slug: PropTypes.string,
    max_attendance: PropTypes.number.isRequired,
    registration_count: PropTypes.number.isRequired,
    featured_image_url: PropTypes.string,
    price_in_cents: PropTypes.string,
    lesson_count: PropTypes.number,
    coach_facility_name: PropTypes.string,
    coach_facility_timezone: PropTypes.string,
    registration_full: PropTypes.bool.isRequired,
    tags: PropTypes.array.isRequired,
    has_waitlist: PropTypes.bool,
  }),
  location: PropTypes.string.isRequired,
  logoImageUrl: PropTypes.string,
}

export default GroupEventSearchResultCard
